module.exports = __webpack_public_path__ + "static/media/assay-genie.bdb6d655.png";